import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { BOTTOM_TABBAR_HEIGHT, MAX_WINDOW_WIDTH, Z_INDEX } from '@constants/layout';
import { Layout } from '@design-system';

export const TabWrapper = styled.nav<{ $noShadow?: boolean }>`
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  max-width: ${MAX_WINDOW_WIDTH}px;
  margin: 0 auto;
  background-color: white;
  height: calc(${BOTTOM_TABBAR_HEIGHT}px + env(safe-area-inset-bottom, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px);
  box-shadow: ${({ $noShadow }) => ($noShadow ? 'none' : '0px -4px 12px 0px rgba(0, 0, 0, 0.16)')};
  z-index: ${Z_INDEX.BOTTOM_TAB};
`;

export const NavTabItem = styled(NavLink)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme.LIGHT_GRAY};
  }

  .active {
    border: 2px solid ${({ theme }) => theme.PRIMARY};
  }
`;

export const StyledTabItem = styled(Layout.FlexCol)`
  position: relative;
`;

export const StyledMessageCount = styled(Layout.Absolute)`
  background-color: ${({ theme }) => theme.SECONDARY};
  border-radius: 8px;
`;

export const TabIconWrapper = styled.div`
  display: grid;
  & > * {
    grid-area: 1 / 1;
  }
  & > .hidden {
    visibility: hidden;
  }
`;
